<template>
    <!-- Adım 4: Kesinleştir. Luca bordrosu yüklendikten sonra BES (bordrodan) ve icra (matrah SGK Hakediş) alınır,
         Banka 1 kaydı yazılıp onaylanır. Uyarılı satırlar kesinleştirilmez (İK kararı). Tasarım: claude.ai/artifact/85Bw2aMArbf95DF7CgfJn5 -->
    <div>
        <b-card class="mb-1">
            <div class="d-flex flex-wrap align-items-center g-1">
                <div class="mr-auto" style="flex:1 1 420px">
                    <h5 class="mb-50">Banka 1'i kesinleştir</h5>
                    <div class="text-muted small">Luca bordrosunu mevcut Luca bordro yükleme ekranından yükledikten sonra kesinleştirin. BES bordrodan alınır, icra SGK Hakediş üzerinden yeniden yazılır, Banka 1 kaydı oluşur ve onaylanır. Uyarılı (kırmızı) satırlar kesinleştirilmez.</div>
                </div>
                <v-executer :loading="running" :action="finalize" variant="secondary">Kesinleştir</v-executer>
            </div>
        </b-card>

        <div class="row">
            <div class="col-md-4 mb-1" v-for="t in tiles" :key="t.label">
                <b-card no-body class="p-1 mb-0 h-100">
                    <div class="small">{{ t.label }}</div>
                    <div class="h4 mb-0 mt-25 font-weight-bolder" :class="t.cls">{{ t.value }}</div>
                </b-card>
            </div>
        </div>

        <b-card no-body class="mb-1">
            <v-table ref="table" :fields="fields" with-items :items="shownRows" pagination="client" row-slot="out" :settings="false">
                <template #additional-actions>
                    <b-form-checkbox v-model="onlyPending">Yalnız kesinleşmeyenler</b-form-checkbox>
                </template>
                <template #row-out="{ row }">
                    <tr :key="row.Id">
                        <td class="text-nowrap font-weight-bold v-table-column-sticky">{{ row.FullName }}</td>
                        <td class="text-right text-nowrap">{{ f(row.SgkHakedis) }}</td>
                        <td class="text-right text-nowrap">{{ f(row.Icra) }}</td>
                        <td class="text-right text-nowrap">{{ row.Finalized ? f(row.Bes) : '—' }}</td>
                        <td class="text-right text-nowrap font-weight-bold">{{ row.Finalized ? f(row.Banka1Odeme) : '—' }}</td>
                        <td>
                            <b-badge v-if="row.Finalized" variant="light-success">Kesinleşti</b-badge>
                            <b-badge v-else :variant="statusVariant(row)" class="text-wrap text-left">{{ statusText(row) }}</b-badge>
                        </td>
                    </tr>
                </template>
            </v-table>
        </b-card>

        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BBadge, BFormCheckbox } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'

const fmt = v => Number(v || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export default {
    components: { BCard, BBadge, BFormCheckbox },
    props: {
        donem: { type: Object, default: () => ({ year: null, month: null }) },
        filter: { type: Object, default: () => ({}) }
    },
    data() {
        const r = name => ({ name, tdClass: 'text-right', thClass: 'vt-th-text-right' })
        return {
            rows: [],
            running: false,
            onlyPending: false,
            fields: [{ name: 'Adı Soyadı', sticky: true }, r('SGK Hakediş'), r('İcra'), r('BES'), r('Ödeme [Banka 1]'), { name: 'Durum' }]
        }
    },
    mounted() {
        this.load()
    },
    computed: {
        shownRows() {
            return this.onlyPending ? this.rows.filter(r => !r.Finalized) : this.rows
        },
        tiles() {
            const done = this.rows.filter(r => r.Finalized).length
            const warn = this.rows.filter(r => !r.Finalized && this.isWarnRow(r)).length
            return [
                { label: 'Kesinleşen', value: done, cls: 'text-success' },
                { label: 'Uyarılı · kesinleşmedi', value: warn, cls: warn ? 'text-danger' : '' },
                { label: 'Diğer (Luca bordrosu yok vb.)', value: this.rows.length - done - warn, cls: 'text-warning' }
            ]
        }
    },
    methods: {
        f: fmt,
        // Hesap uyarısı (eksi prim / Banka 2 kontrol) taşıyan satır; Luca/kilit gibi durum mesajları hariç.
        isWarnRow(row) {
            return (row.Warnings || []).some(w => / eksi çıktı| sıfır değil|Uyarılı satır/.test(w))
        },
        statusText(row) {
            const w = row.Warnings || []
            if (this.isWarnRow(row)) return 'Uyarılı satır; önce 3. adımda düzeltin'
            return w.length ? w[w.length - 1] : 'Kesinleştirilmedi'
        },
        statusVariant(row) {
            return this.isWarnRow(row) ? 'light-danger' : 'light-warning'
        },
        load() {
            this.$refs.table?.setLoading(true)
            EmployeeOperationsApi.DomesticDriverSalary.Table({ ...this.filter, PaginateRequest: { QueryParam: '' } }).then(res => {
                if (res.data.Success) this.rows = res.data.Data || []
                else this.$result(res)
                this.$refs.table?.setLoading(false)
            }).catch(err => {
                this.$result(null, err)
                this.$refs.table?.setLoading(false)
            })
        },
        async finalize() {
            const c = await this.$confirm('Kesinleştirmek istediğinize emin misiniz?', 'Uyarısız satırlar için Banka 1 kaydı yazılacak ve onaylanacak; icra ödemeleri bu dönem için yeniden yazılacak. Uyarılı satırlar kesinleştirilmez.')
            if (!c) return
            this.running = true
            EmployeeOperationsApi.DomesticDriverSalary.Finalize({ ...this.filter, PaginateRequest: { QueryParam: '' } }).then(res => {
                if (res.data.Success) this.rows = res.data.Data || []
                this.$result(res)
                this.running = false
            }).catch(err => {
                this.$result(null, err)
                this.running = false
            })
        }
    }
}
</script>
